import axiosInstance from "./AxiosInstance";

export const createPrintQR = (payload) => {
  return axiosInstance.post("/stock/createqrcode", payload);
};

export const getPrintQRList = () => {
  return axiosInstance.post("/stock/qrcodeList");
};